/**
 * Hiring Manager Portfolio Review configuration for the /portfolio-review
 * page (/coaching redirects here). A live hiring-manager review of a
 * designer's portfolio: a free 15-minute intro plus a paid 60-minute session
 * ($99). Booking is handled by Cal.com.
 */

/** Free 15-minute review — existing Cal.com event. */
export const PORTFOLIO_REVIEW_FREE_CAL_URL =
  "https://cal.com/guidione-machava-1gryqg/free-portfolio-review";

/**
 * Paid 60-minute Hiring Manager Portfolio Review ($99). Payment ($99) is
 * collected on Cal at checkout. Override with NEXT_PUBLIC_PAID_SESSION_CAL_URL
 * if the event slug ever changes.
 */
export const PORTFOLIO_REVIEW_PAID_CAL_URL =
  process.env.NEXT_PUBLIC_PAID_SESSION_CAL_URL ||
  "https://cal.com/guidione-machava-1gryqg/hiring-manager-portfolio-review";

export const PORTFOLIO_REVIEW_PRICE_DISPLAY = "$99";
